module.exports = __webpack_public_path__ + "static/img/default_logo.af6d418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default_logo.png
// module id = jKIa
// module chunks = 1